import { Button } from '@/components/ui/button';
import { PDKAddIcon } from '@/components/ui/pdk-icons';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Deal, PrimaryCustomer } from '@/models/registry';
import { coRegistrantStore, customerAddressStore } from '@/models/stores';
import type { Address, Customer } from '@/models/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';

const CoRegistrantCreateButton = ({
  dealId,
  customerId,
}: {
  dealId: Deal['id'];
  customerId: PrimaryCustomer['id'];
}) => {
  const queryClient = useQueryClient();
  const createCoRegistrantMutation = useMutation({
    onMutate: async ({
      coRegistrant,
      address,
    }: {
      coRegistrant: Customer;
      address: Address;
    }) => {
      // todo: need to fix this up to work with the address
      // dealStore.updateCoRegistrant({
      //   coRegistrant,
      //   id: dealId,
      // });
      coRegistrantStore.add(coRegistrant);
      customerAddressStore.add(address);
    },
    mutationFn: async ({
      coRegistrant,
      address,
    }: {
      coRegistrant: Customer;
      address: Address;
    }): Promise<Customer> => {
      // /deals/:id/co-registrant/:customer_id/create
      const response = await pdkAxios
        .post(`/deals/${dealId}/co-registrant/${customerId}/create`, {
          id: coRegistrant.id,
          address_id: address.id,
        })
        .catch((e) => {
          console.error('Error creating co-registrant', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error creating co-registrant', error, variables);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', dealId] });
    },
  });
  return (
    <Button
      variant="ghost"
      className="p-0 h-fit w-fit text-gray-500 dark:text-white"
      onClick={() => {
        const coRegistrantId = uuidv4();

        createCoRegistrantMutation.mutate({
          coRegistrant: {
            id: coRegistrantId,
            deal_id: dealId,
            customer_type: 'co_registrant',
            full_name: '',
            email: '',
            mobile_number: '',
          },
          address: {
            id: uuidv4(),
            customer_id: coRegistrantId,
            address_type: 'registration',
            address_line_1: '',
            address_line_2: '',
            city: '',
            state: '',
            postal_code: '',
          },
        });
      }}
    >
      <PDKAddIcon className="w-2 h-2 dark:text-white" />
    </Button>
  );
};

export default CoRegistrantCreateButton;
